<div class="projekt-filter" cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <button
    type="button"
    class="projekt-filter__alle"
    data-testid="dash-projektfilter-alle"
    [class.projekt-filter__alle--active]="allSelected()"
    [attr.aria-pressed]="allSelected()"
    [disabled]="disabled()"
    (click)="selectAll()"
  >
    {{ 'liveDashboard.projektFilter.alle' | translate }}
  </button>
  <button
    #trigger
    type="button"
    class="projekt-filter__trigger"
    data-testid="dash-projektfilter"
    aria-haspopup="listbox"
    [class.projekt-filter__trigger--active]="!allSelected()"
    [attr.aria-expanded]="open()"
    [attr.title]="state() === 'error' ? ('liveDashboard.projektFilter.ladeFehler' | translate) : null"
    [disabled]="disabled()"
    (click)="toggleOpen()"
  >
    <mat-icon class="projekt-filter__folder" aria-hidden="true">folder</mat-icon>
    <span class="projekt-filter__label">
      @if (allSelected()) {
        {{ 'liveDashboard.projektFilter.alleProjekte' | translate }}
      } @else if (selected().length === 1) {
        {{ singleName() }}
      } @else {
        {{ 'liveDashboard.projektFilter.nProjekte' | translate: { n: selected().length } }}
      }
    </span>
    <mat-icon class="projekt-filter__chevron" [class.projekt-filter__chevron--open]="open()" aria-hidden="true">
      chevron_right
    </mat-icon>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayPositions]="positions"
  (backdropClick)="close()"
  (detach)="close()"
>
  <div
    #listbox
    class="projekt-filter__liste"
    role="listbox"
    aria-multiselectable="true"
    data-testid="dash-projektfilter-liste"
    [attr.aria-label]="'liveDashboard.projektFilter.listeLabel' | translate"
  >
    @for (option of options(); track option.id; let index = $index) {
      <div
        class="projekt-filter__option"
        role="option"
        tabindex="0"
        data-testid="dash-projektfilter-option"
        [attr.aria-selected]="option.selected"
        [attr.title]="option.last ? ('liveDashboard.projektFilter.mindestensEins' | translate) : null"
        (click)="toggle(option.id)"
        (keydown)="onOptionKeydown($event, index, option.id)"
      >
        <span class="projekt-filter__check" [class.projekt-filter__check--on]="option.selected" aria-hidden="true">
          @if (option.selected) {
            <mat-icon>check</mat-icon>
          }
        </span>
        <span
          class="projekt-filter__color"
          [style.background]="'var(' + option.colorVar + ')'"
          aria-hidden="true"
        ></span>
        <span class="projekt-filter__name">{{ option.name }}</span>
      </div>
    }
    <div class="projekt-filter__footer">
      <span class="projekt-filter__footer-text">
        @if (allSelected()) {
          {{ 'liveDashboard.projektFilter.alleAusgewaehlt' | translate }}
        } @else {
          {{ 'liveDashboard.projektFilter.nVonM' | translate: { n: selected().length, m: projects().length } }}
        }
      </span>
      <button
        type="button"
        class="projekt-filter__select-all"
        data-testid="dash-projektfilter-alle-auswaehlen"
        [disabled]="allSelected()"
        (click)="selectAll()"
      >
        {{ 'liveDashboard.projektFilter.alleAuswaehlen' | translate }}
      </button>
    </div>
  </div>
</ng-template>
